/** Fixed datasets owned by Agent View. */
export enum AgentViewWorkspaceCapabilityUdoTemplateKey {
    capacity = "c292dedb-777a-47a0-bdf6-a5f15fddeb1f",
    dayPlanItem = "49112ebd-e082-42c3-9df6-f1c585f3043c",
    dayPlanRun = "d63c6c28-d35b-461d-a61f-646e9c6753bb",
}
